// extracted by css-extract-rspack-plugin
export default {"uploadAlert":"uploadAlert-DrP6Wj","dropzone":"dropzone-fGezZD"};